export const primary_color = '#049FDB'
export const success_color = '#28a745'

export const container_width = '1440px'